import { Component, ElementRef, OnInit } from '@angular/core';
import { Broadcaster } from '../../service/Broadcaster';
import { Observable } from 'rxjs/Rx';
import { SingService } from '../../service/sing.service';
import { updateCategories } from 'app/components/class/broadcaster/update-categories';
import {  AddCampaignInit } from 'app/components/class/broadcaster/add-campaign/add-campaign-init';
import { responseGetExpense } from 'app/components/class/http/res/response-get-expense';

@Component({
    selector: 'budget-add-campaign',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.css']
})
export class BudgetAddCampaignComponent implements OnInit {
    title = '';
    category;
    product;
    expenses = [];
    categories;
    data;


    constructor(private broadcaster: Broadcaster, private elRef: ElementRef, private httpService: SingService) { }

    ngOnInit() {
        this.broadcaster.on<any>("updateCategories").subscribe((data:updateCategories) => {
            this.categories = data.categories;
           
        })
        this.broadcaster.on<any>("sendBudgetData").subscribe(data => {
            this.categories = data.data.categories;
            this.data = data.data;
        })
        this.broadcaster.on<any>("sendNewBudgetData").subscribe(data => {
            this.data = data.data;
        })
        this.broadcaster.on<any>('addCampaign').subscribe((data:AddCampaignInit) => {
            document.querySelector(".addCampaignModal").classList.remove('hid');
            document.querySelector(".budgetContainer").classList.add('blur');
            this.category = data.dataId.i;
            this.product = data.dataId.u;
            let ex = [];
            let num = 0;
            for (let i of this.categories[this.category].products[this.product].expenses) {
                if (i.id > 0) {
                    ex.push(i);
                    num++
                }
            }
            for (let i of ex) {
                this.httpService.getExpense(i.id).subscribe((data:responseGetExpense) => {
                    this.expenses.push(data.expense)
                })
            }
        })
    }
    changeInput(e) {
        this.title = e.target.value;
    }
    submit() {
        this.broadcaster.broadcast("submitCampaign", {
            title: this.title,
            category: this.category,
            product: this.product,
            expenses: this.expenses
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/components/budget/add/add.component.ts